function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import times from 'lodash/times';
import messages from '../../../messages';
import styles from '../NotificationsPopover.pcss';
export const Loader = ()=>/*#__PURE__*/ _jsx("ul", {
        className: styles.notifications__list,
        children: times(5, (idx)=>/*#__PURE__*/ _jsx("li", {
                className: styles.notifications__notification,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.notifications__notification__inner,
                    children: /*#__PURE__*/ _jsx("p", {
                        className: cn(styles.notifications__notification__textPlaceholder, 'fadingLoader w-100')
                    })
                })
            }, idx))
    });
export const NoNotifications = ()=>/*#__PURE__*/ _jsx("div", {
        className: styles.notifications__list,
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.notifications__notification,
            children: /*#__PURE__*/ _jsx("div", {
                className: `${styles.notifications__notification__inner} text--muted`,
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.noNotifications))
            })
        })
    });
